import React from 'react';
import PropTypes from 'prop-types';
import Paginator from 'paginator';
import Grid from '@material-ui/core/Grid';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import PageLink from './PageLink';

const propTypes = {
  count: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  pagesDisplayed: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
};

function Pages(props) {
  const {
    count,
    page,
    pagesDisplayed,
    rowsPerPage,
    onChangePage,
  } = props;

  const itemsCountPerPage = rowsPerPage;
  const pageRangeDisplayed = pagesDisplayed;
  const totalItemsCount = count;
  const activePage = page + 1;

  const paginationInfo = new Paginator(
    itemsCountPerPage,
    pageRangeDisplayed,
  ).build(totalItemsCount, activePage);

  function handleChangePage(toPage) {
    return function handleGoToPage(e) {
      onChangePage(e, toPage - 1);
    };
  }

  function renderFirsPageButton() {
    // eslint-disable-next-line camelcase
    const { has_previous_page } = paginationInfo;
    // eslint-disable-next-line camelcase
    const isDisabled = !has_previous_page;
    return (
      <PageLink
        onClick={handleChangePage(1)}
        aria-label="First page"
        disabled={isDisabled}
      >
        <FirstPageIcon />
      </PageLink>
    );
  }

  function renderPreviousPageButton() {
    // eslint-disable-next-line camelcase
    const { has_previous_page, previous_page } = paginationInfo;
    // eslint-disable-next-line camelcase
    const isDisabled = !has_previous_page;
    return (
      <PageLink
        onClick={handleChangePage(previous_page)}
        aria-label="Previous page"
        disabled={isDisabled}
      >
        <KeyboardArrowLeftIcon />
      </PageLink>
    );
  }

  function renderNextPageButton() {
    // eslint-disable-next-line camelcase
    const { has_next_page, next_page } = paginationInfo;
    // eslint-disable-next-line camelcase
    const isDisabled = !has_next_page;
    return (
      <PageLink
        onClick={handleChangePage(next_page)}
        aria-label="Next page"
        disabled={isDisabled}
      >
        <KeyboardArrowRightIcon />
      </PageLink>
    );
  }

  function renderLastPageButton() {
    // eslint-disable-next-line camelcase
    const { has_next_page, total_pages } = paginationInfo;
    // eslint-disable-next-line camelcase
    const isDisabled = !has_next_page;
    return (
      <PageLink
        onClick={handleChangePage(total_pages)}
        aria-label="Last page"
        disabled={isDisabled}
      >
        <LastPageIcon />
      </PageLink>
    );
  }

  function renderPages() {
    const element = [];
    for (
      let i = paginationInfo.first_page;
      i <= paginationInfo.last_page;
      i += 1
    ) {
      const isActive = i - 1 === page;
      element.push(
        <PageLink
          key={i}
          isActive={isActive}
          onClick={handleChangePage(i)}
          aria-label={`Page ${i}`}
        >
          {i}
        </PageLink>,
      );
    }
    return element;
  }

  const firstPageButton = renderFirsPageButton();
  const previousPageButton = renderPreviousPageButton();
  const pageList = renderPages();
  const nextPageButton = renderNextPageButton();
  const lastPageButton = renderLastPageButton();

  return (
    <Grid container item xs={12} justify="flex-end">
      {firstPageButton}
      {previousPageButton}
      {pageList}
      {nextPageButton}
      {lastPageButton}
    </Grid>
  );
}

Pages.propTypes = propTypes;

export default Pages;
